export const funnelConstants = {
  CLEAR_STATE: 'funnel/CLEAR_STATE',
  SET_QUESTIONS: 'funnel/SET_QUESTIONS',
  UPDATE_USER_INFO: 'funnel/UPDATE_USER_INFO',
  UPDATE_USER_DAUGHTERS_INFO: 'funnel/UPDATE_USER_DAUGHTERS_INFO',
};
